module.exports = "<svg class=\"menu-button-support-icon-chevron\" viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.963 4.89L3.068 9.24l.505.76L6.71 5.286 7 4.878 3.522 0 3 .733\" fill=\"#999\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/chevron-right.svg
// module id = 130
// module chunks = 0 1